import React, { useState } from 'react';
import clsx from 'clsx';

import icon from '@atom/images/location-link.svg';
import { IconButton, List, Popover } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { LocationLinkOption } from '@atom/types/map';

import classes from './locationLinkControls.module.css';

const { ListItemButton } = List;

export interface Props {
  locationLinkOptions: LocationLinkOption[];
  disabled?: boolean;
}

const styles = {
  listItem: {
    fontSize: fonts.md,
    color: colors.neutral.dark,
    fontWeight: 500,
  },
};

const LocationLinkControls = ({
  locationLinkOptions = [],
  disabled,
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [open, setOpen] = useState<boolean>(false);

  const handleToggle = event => {
    if (!disabled) {
      setOpen(!open);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClosePopover = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleClick = ({ onClick }: LocationLinkOption) => {
    onClick();
    handleClosePopover();
  };

  return (
    <div className={clsx(classes.container, disabled && classes.disabled)}>
      <IconButton
        disabled={disabled}
        tooltip="Location Sync"
        onClick={handleToggle}
      >
        <img className={classes.icon} src={icon} />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        onClose={handleClosePopover}
      >
        <List style={styles.listItem}>
          {locationLinkOptions.map(option => {
            return (
              <ListItemButton
                key={option.text}
                onClick={() => handleClick(option)}
              >
                {option.text}
              </ListItemButton>
            );
          })}
        </List>
      </Popover>
    </div>
  );
};

export default LocationLinkControls;
